export const STORAGE_KEY = Object.freeze({
    COOKIES_CONSENT: 'COOKIES_CONSENT'
})
